import { render, staticRenderFns } from "./GeneralPage.vue?vue&type=template&id=159fe830&scoped=true&"
import script from "./GeneralPage.vue?vue&type=script&lang=ts&"
export * from "./GeneralPage.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralPage.vue?vue&type=style&index=0&id=159fe830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159fe830",
  null
  
)

export default component.exports